import React from 'react'

import { NotificationController, NotificationTemplate } from 'core-components/library/popup'

export const success = (message: string, autoClose: boolean = true) => {
  NotificationController.show({
    autoHide: autoClose,
    content: (contentData) => (
      <NotificationTemplate
        closePopup={contentData.close}
        content={message}
        closeButtonVisible={true}
        type={'success'}
      />
    ),
  })
}

export const fail = (message: string, autoClose: boolean = true) => {
  NotificationController.show({
    autoHide: autoClose,
    content: (contentData) => (
      <NotificationTemplate
        closePopup={contentData.close}
        content={message}
        closeButtonVisible={true}
        type={'danger'}
      />
    ),
  })
}
